import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { key: 1 }


    import { IEmergencyAddress } from '../../types/sse-types';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'EmergencyAddress',
  props: {
        address: { type: Object as () => IEmergencyAddress, required: true }
    },
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return (Object.keys(__props.address).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("b", null, [
          _createTextVNode(_toDisplayString(__props.address.address_line1) + " " + _toDisplayString(__props.address.address_line2 ? __props.address.address_line2 : undefined), 1),
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(__props.address.city) + " " + _toDisplayString(__props.address.state_code) + " " + _toDisplayString(__props.address.zip), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, " Undefined "))
}
}

})